var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warrants-wrapper rk-section"},[_c('WarrantList',{attrs:{"total":20}}),_c('div',{staticClass:"show-more",on:{"click":_vm.changeRouter}},[_vm._v(_vm._s(_vm.$t('查看更多'))+" "),_c('i',{staticClass:"iconfont icon-xiangxia"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }